import _fp from "lodash/fp"
import { createRenderSlice, RenderState } from "@fusion-advantage/formrender"
import { restoreRenderSliceSettings } from "../lib/setting"
import { updateRenderState } from "../lib/relay/updateRenderState"
import { resetAppFormState } from "./actions"

const appRenderSlice = createRenderSlice(
	(builder) => {
		builder.addCase(restoreRenderSliceSettings, (state, action): RenderState => {
			return {
				...state,
				...action.payload,
			}
		})
		// update the state of appRenderSlice—
		// these updates automatically get forwarded to formRenderSlice within
		// the renderer; see comments on createRenderSlice for details
		builder.addCase(updateRenderState, (state, action): RenderState => {
			// we jump through hoops here to keep the `export` object reference
			// the same so that the equality checks in legacy renderers'
			// formDraftMiddleware work as intended
			const currentExport = state.form?.export ?? null
			const newState = _fp.merge(state, action.payload)
			if(action.payload.form?.export === undefined && newState.form) {
				newState.form.export = currentExport
			}
			return newState
		})
		builder.addCase(resetAppFormState, (state): RenderState => {
			return {
				...state,
				form: null,
			}
		})
	}
)

export default appRenderSlice.reducer
